// import { Snackbar } from "@mui/material";
import { checkTokenExpiry, getRefreshToken } from "../Services/AllServices";
// const anchorOrigin = { vertical: "top", horizontal: "right" };

//------------------------- Name -------------------------//
export const setName = async (name) => {
  try {
    localStorage.setItem("name", name);
  } catch (error) {
    console.log("error settng name", error);
  }
};

export const getName = async () => {
  try {
    let name = localStorage.getItem("name");
    return name;
  } catch (error) {
    console.log("error getting name", error);
  }
};

//------------------------- Profile -------------------------//
export const setProfile = async (profile) => {
  try {
    localStorage.setItem("profile", profile);
  } catch (error) {
    console.log("Error setting profile", error);
  }
};

export const getProfile = async () => {
  try {
    let profile = localStorage.getItem("profile");
    return profile;
  } catch (error) {
    console.log("Error getting profile", error);
  }
};

//------------------------- Token -------------------------//
export const setToken = async (token) => {
  try {
    localStorage.setItem("access_token", token);
  } catch (error) {
    console.log("Error setting token", error);
  }
};

export const refreshToken = async () => {
  const old_token = localStorage.getItem("access_token");
  try {
    const res = await getRefreshToken(old_token);
    console.log(res);
  } catch (error) {
    console.log("error in refreshtoken", error);
  }
};

export const getToken = async () => {
  try {
    const token = localStorage.getItem("access_token");
    const checkExpiry = await checkTokenExpiry(token);
    // console.log("check expiry", checkExpiry);
    if (checkExpiry?.status === "valid") {
      return token;
    } else if (checkExpiry?.status === "renewed") {
      await setToken(checkExpiry?.data?.new_token);
      return checkExpiry?.data?.new_token;
    } else if (checkExpiry?.status === "expired") {
      window.dispatchEvent(
        new CustomEvent("tokenStatus", {
          detail: {
            status: checkExpiry?.status,
            code: checkExpiry?.code,
          },
        })
      );
      return null;
    } else if (checkExpiry?.status === "error" && checkExpiry?.code === 404) {
      window.dispatchEvent(
        new CustomEvent("tokenStatus", {
          detail: {
            status: checkExpiry?.status,
            code: checkExpiry?.code,
          },
        })
      );
      return null;
    }
  } catch (error) {
    console.log("Error getting or validating token", error);
    // return null;
  }
};

//------------------------- UserID -------------------------//
export const setUserID = async (userId) => {
  try {
    localStorage.setItem("user_id", userId);
  } catch (error) {
    console.log("Error setting userID", error);
  }
};

export const getUserID = async () => {
  try {
    let userId = localStorage.getItem("user_id");
    return userId;
  } catch (error) {
    console.log("Error getting userID", error);
  }
};

//------ checking whether they downloaded the build ------//
// export const setDownloadCount = async (downloadCount) => {
//   try {
//     localStorage.setItem("downloadCheck", downloadCount);
//   } catch (error) {
//     console.log("Error setting download check", error);
//   }
// };

// export const getDownloadCount = async () => {
//   try {
//     let token = localStorage.getItem("downloadCheck");
//     return token;
//   } catch (error) {
//     console.log("Error getting download check", error);
//   }
// };
